<template>
    <div>       
        <b-tabs fill v-model="tabIndex">
            <b-tab title="Factura" active>
                <nota-credito-factura-emision></nota-credito-factura-emision>
            </b-tab>
            <b-tab title="Emitidas - F">
                <nota-credito-factura-consulta></nota-credito-factura-consulta>
            </b-tab>
            <b-tab title="Boleta">
                <nota-credito-boleta-emision></nota-credito-boleta-emision>
            </b-tab>
            <b-tab title="Emitidas - B">
                <nota-credito-boleta-consulta></nota-credito-boleta-consulta>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import NotaCreditoFacturaEmision from '@/components/notacredito/NotaCreditoFacturaEmision'
import NotaCreditoFacturaConsulta from '@/components/notacredito/NotaCreditoFacturaConsulta'
// import NotaCreditoBoletaEmision from '@/components/notacredito/NotaCreditoBoletaEmision'
// import NotaCreditoBoletaConsulta from '@/components/notacredito/NotaCreditoBoletaConsulta'
export default {
    name: 'NotaCredito',
    components: {
        NotaCreditoFacturaEmision,
        NotaCreditoFacturaConsulta,
        NotaCreditoBoletaEmision,
        NotaCreditoBoletaConsulta
    },
    data: () => {
        return {
            tabIndex: 0
        }
    }
}
</script>

